import { f7ready } from "framework7-react";
import { onMessageListener, requestFirebaseNotificationPermission } from "../firebase/firebase";
import { loginServices } from "services/login/login.services";
import { UAParser } from "ua-parser-js";
import { v4 as uuidv4 } from 'uuid';

// get user details from storage
export const getUserDetails = () => {
    const userDetails = localStorage.getItem("userDetails") !== null ? JSON.parse(localStorage.getItem("userDetails") || "") : null;
    if (userDetails) {
      return userDetails;
    } else {
      return "";
    }
  }

// check if it is mobile device or not
export const isMobileDevice = () => {
  let isMobile = window.matchMedia && window.matchMedia("(max-width: 480px)").matches;
  return isMobile;
}

// get cart detail from storage
export const getCartDetailFromStorage = () => {
  let cartDetail = localStorage.getItem("cartDetail");
  if(cartDetail !== null && cartDetail != "undefined"){
    cartDetail = JSON.parse(localStorage.getItem("cartDetail") || "")
  }
  else{
    cartDetail = null;
  }
  return cartDetail;
}

export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject("Geolocation not supported");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const location = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };

        resolve(location);
      },
      (error) => reject(error),
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 10000
      }
    );
  });
};

// common function for set focus on header in login popup when popup open :: ADA :: 04-07-2023
export const setFocusOnHeaderInLoginPopup = (e) => {
  f7ready((f7) => {
    let popup = f7.popup.get('.loginModel');
    if (popup) {
      popup.open();
    }
    setTimeout(() => {
      let mainLoginPopupModal = document.querySelector("#popupLogin") as any;
      if (mainLoginPopupModal) {
        let headerElement = mainLoginPopupModal.getElementsByClassName('cardHeader')[0]?.querySelector('.heading') as any;
        headerElement?.focus();
        mainLoginPopupModal.setAttribute("tabIndex", "0");
        let elementArray = mainLoginPopupModal.getElementsByTagName("a") as any;
        if (elementArray) {
          for (let i = 0; i < elementArray.length; i++) {
            if (elementArray[i].classList.contains("external")) {
              elementArray[i].addEventListener('keydown', onKeyDownSetFocusFromLastToFirstElement);
              elementArray[i].firstElement = mainLoginPopupModal;
            }
          }
        }
      }
    }, 500)
    // if (e?.detail === 0) {
    //   setTimeout(() => {
    //     let mainLoginPopupModal = document.querySelector("#popupLogin") as any;
    //     if (mainLoginPopupModal) {
    //       let headerElement = mainLoginPopupModal.getElementsByClassName('cardHeader')[0].querySelector('.heading') as any;
    //       headerElement.focus();
    //       mainLoginPopupModal.setAttribute("tabIndex", "0");
    //       let elementArray = mainLoginPopupModal.getElementsByTagName("a") as any;
    //       if (elementArray) {
    //         for (let i = 0; i < elementArray.length; i++) {
    //           if (elementArray[i].classList.contains("external")) {
    //             elementArray[i].addEventListener('keydown', onKeyDownSetFocusFromLastToFirstElement);
    //             elementArray[i].firstElement = mainLoginPopupModal;
    //           }
    //         }
    //       }
    //     }
    //   }, 500)
    // }
    // else if (e?.detail === 1) {
    //   setTimeout(() => {
    //     let mainLoginPopupModal = document.querySelector("#popupLogin") as any;
    //     if (mainLoginPopupModal) {
    //       let textInputPhoneNumber = mainLoginPopupModal.querySelector("#txtPhonenumber") as any;
    //       if (textInputPhoneNumber) {
    //         textInputPhoneNumber.focus();
    //       }
    //     }
    //   }, 500)
    // }
    // else{
      
    // }
  });
} 

// set focus from last element to first element on login popup
const onKeyDownSetFocusFromLastToFirstElement = (e) => {
  if(e.keyCode === 9) {
    e.target.firstElement.focus();
  }
}

// convert price value in us format "$1,234,567.89"
export const formatPrice = (number: any) => {
  let formatValue = number.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return formatValue.replace("$", ""); // replace $ sign to empty coz we already put that sign in page
}



// get location permission
export const askLocationPermission = (): Promise<"granted" | "denied"> => {
  try {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve("denied");
        return;
      }
      navigator.geolocation.getCurrentPosition(
        () => resolve("granted"),
        (err) => {
          if (err.code === err.PERMISSION_DENIED) {
            resolve("denied");
          } else {
            resolve("denied");
          }
        }
      );
    });
  }
  catch (e) {
    console.log("error when ask location permission");
    return new Promise((resolve) => {
      resolve("denied");
      return;
    });
  }
};

// ask notification permission and get firebase token for push notification
export const askNotificationPermission = async () => {
  let isWebViewAvailable = (window as any).checkIsWebViewAvailable();
  let firebaseData = {} as any;
  if (isWebViewAvailable === true) {
    const tokenData = await (window as any).getDeviceInfoAndToken();
    if (tokenData) {
      console.log("tokenData>>>>>>>>>>>>", tokenData.uniqueId);
      firebaseData.deviceNotificationToken = tokenData.token;
      firebaseData.deviceUniqueId = tokenData.uniqueId;
      firebaseData.deviceMake = tokenData.make;
      firebaseData.deviceModel = tokenData.model;
      firebaseData.deviceOs = tokenData.device ? tokenData.device === "android" ? 2 : 1 : 2

      saveDeviceInfo(firebaseData);
    }
  }
  else {
    requestFirebaseNotificationPermission().then((token) => {
      if (token) {
        console.log("FCM Token:", token);
        const parser = new UAParser();
        const result = parser.getResult();

        let storageUniqueId = localStorage.getItem("deviceUniqueId");
        if(!storageUniqueId){
          let guid = uuidv4();
          localStorage.setItem("deviceUniqueId", guid);
          storageUniqueId = guid;
        }
        
        firebaseData.deviceNotificationToken = token;
        firebaseData.deviceUniqueId = storageUniqueId;
        firebaseData.deviceMake = result ? result?.browser?.name : "";
        firebaseData.deviceModel = result ? result?.browser?.version : "";
        firebaseData.deviceOs = 3;

        saveDeviceInfo(firebaseData);
        // dispatch({ type: actionTypes.SET_FIREBASE_TOKEN, firebaseToken: token });
      }
    });

    // Foreground message listener
    const unsubscribe = onMessageListener((payload: any) => {
      console.log("Foreground message received:", payload);

      if (Notification.permission === "granted" && "serviceWorker" in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.showNotification(
            payload.data?.title ?? "New Message",
            {
              body: payload.data?.body ?? "",
              icon: "/Yodel192.png",
              tag: payload.data?.messageId,
              requireInteraction: true,
              data: {
                actionUrl: payload.data?.actionUrl ?? "https://portal-dev.yodelpass.com",
                messageId: payload.data?.messageId,
              },
            } as NotificationOptions
          );
        });
      }
    });

    return () => {
      unsubscribe();
    };
  }
}

// save notification subscription token and device info 
const saveDeviceInfo = async (deviceInfo: any) => {
  let savedDeviceInfo = await loginServices.saveDeviceInfo(deviceInfo);
  localStorage.setItem("isNotificationPermissionAsked", "true");
}

// check notification permission is already asked or not for already user logged in
export const checkIsNotificationPermissionAsked = () => {
  let isNotificationPermissionAsked = localStorage.getItem("isNotificationPermissionAsked");
  if (isNotificationPermissionAsked === "true") {

  }
  else {
    askNotificationPermission();
    localStorage.setItem("isNotificationPermissionAsked", "true");
  }
}

